"use client";

import Image from "next/image";
import { Heading } from "@/components/ui/typography";
import Link from "next/link";

const issues = [
  "Unclear business activity descriptions submitted",
  "Incomplete or improperly formatted documentation",
  "High-risk classification misunderstandings",
  "Incorrect institution selected for company structure",
  "Application submitted before structure planning completed",
];

export default function WhyItGoesWrong({ heading = "Why Many Founders Get Rejected Before Working With Us" }: { heading?: string } = {}) {
  return (
    <section className="py-[30px] md:py-[60px] px-4">
      <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row gap-8 items-center">
        {/* IMAGE */}
        <div className="w-full lg:w-1/2">
          <Image
            src="/banking-setup/image-2510.webp"
            alt="Why it goes wrong"
            width={600}
            height={500}
            className="w-full h-full object-cover rounded-xl"
          />
        </div>

        {/* CONTENT */}
        <div className="w-full lg:w-1/2 flex flex-col gap-6">
          {/* HEADING */}
          <div className="space-y-4">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-white/70 text-[16px] md:text-[18px] leading-[160%]">
              Most banking rejections happen for one of these reasons. Once
              rejected, approval becomes harder. That’s why choosing the right
              path first matters.
            </p>
          </div>

          {/* LIST */}
          <div className="flex flex-col gap-2">
            {issues.map((item, i) => (
              <div
                key={i}
                className="bg-[#FF6067]/10 border-l-2 border-[#FF6067] rounded-md px-4 py-3 flex gap-3 items-center"
              >
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.75"
                    y="0.75"
                    width="17.5"
                    height="17.5"
                    rx="8.75"
                    fill="white"
                  />
                  <rect
                    x="0.75"
                    y="0.75"
                    width="17.5"
                    height="17.5"
                    rx="8.75"
                    stroke="#FF6067"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M6.70117 12.2986L12.2998 6.70148M6.70117 6.70148L12.2998 12.2986"
                    stroke="#FF6067"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>

                <p className="text-white text-[15px] md:text-[18px] leading-[150%]">
                  {item}
                </p>
              </div>
            ))}
          </div>

          {/* FOOTER TEXT */}
          <p className="text-white/70 text-[16px] md:text-[18px] leading-[160%]">
            <Link
              href="/hong-kong-business-banking"
              className="hover:underline"
            >
              Banking Setup
            </Link>{" "}
            is included in our formation structures. Many founders discover
            banking problems after incorporation — MuteTaxes handles both
            together so your company becomes operational faster.
          </p>
        </div>
      </div>
    </section>
  );
}
